'use strict';

// Enhance the server-rendered event list; all event links remain usable without JS.
function initialiseEvents() {
    const hub = document.querySelector('[data-events-hub]');
    if (hub) {
        const list = hub.querySelector('#events-list');
        const calendar = hub.querySelector('#events-calendar');
        const year = hub.querySelector('#events-year');
        const month = hub.querySelector('#events-month');
        const grid = hub.querySelector('[data-calendar-grid]');
        const switches = Array.from(hub.querySelectorAll('[data-events-view]'));
        const cards = Array.from(list.querySelectorAll('[data-event-start]')).filter(card => /^\d{4}-\d{2}-\d{2}$/.test(card.dataset.eventStart));
        let calendarVisible = false;
        const currentMonth = new Date().toLocaleDateString('sv-SE', { timeZone: 'America/Los_Angeles' }).slice(0, 7);
        month.value = cards.length ? cards[0].dataset.eventStart.slice(0, 7) : currentMonth;
        hub.querySelector('.events-year-filter').hidden = false;
        hub.querySelector('.events-view-switch').hidden = false;

        function renderCalendar() {
            const match = /^(\d{4})-(\d{2})$/.exec(month.value);
            if (!match) return;
            const y = Number(match[1]);
            const m = Number(match[2]) - 1;
            const first = new Date(Date.UTC(y, m, 1));
            const last = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
            grid.replaceChildren();
            hub.querySelector('[data-calendar-title]').textContent = first.toLocaleDateString('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' });
            ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].forEach(day => {
                const heading = document.createElement('div');
                heading.className = 'event-calendar-weekday';
                heading.textContent = day;
                grid.appendChild(heading);
            });
            for (let i = 0; i < Math.ceil((first.getUTCDay() + last) / 7) * 7; i++) {
                const cell = document.createElement('div');
                cell.className = 'event-calendar-cell';
                const day = i - first.getUTCDay() + 1;
                if (day >= 1 && day <= last) {
                    const date = new Date(Date.UTC(y, m, day)).toISOString().slice(0, 10);
                    const label = document.createElement('span');
                    label.textContent = String(day);
                    cell.appendChild(label);
                    cards.filter(card => !card.closest('.event-card-wrap').hidden && card.dataset.eventStart <= date && (card.dataset.eventEnd || card.dataset.eventStart) >= date).forEach(card => {
                        const link = document.createElement('a');
                        link.href = card.dataset.eventUrl;
                        link.textContent = card.dataset.eventTitle;
                        link.setAttribute('aria-label', card.dataset.eventTitle + ', ' + date);
                        cell.appendChild(link);
                    });
                } else {
                    cell.setAttribute('aria-hidden', 'true');
                }
                grid.appendChild(cell);
            }
        }

        function updateSelection() {
            hub.querySelectorAll('.event-card-wrap').forEach(wrap => { wrap.hidden = Boolean(year.value && !wrap.dataset.eventYears.split(' ').includes(year.value)); });
            const hasUpcoming = Array.from(list.querySelectorAll('.event-card-wrap')).some(wrap => !wrap.hidden);
            const hasPast = Array.from(hub.querySelectorAll('#past-events .event-card-wrap')).some(wrap => !wrap.hidden);
            hub.querySelector('[data-upcoming-empty]').hidden = hasUpcoming;
            hub.querySelector('[data-past-empty]').hidden = hasPast;
            list.hidden = calendarVisible;
            calendar.hidden = !calendarVisible;
            switches.forEach(button => button.setAttribute('aria-pressed', String((button.dataset.eventsView === 'calendar') === calendarVisible)));
            renderCalendar();
        }

        switches.forEach(button => button.addEventListener('click', () => { calendarVisible = button.dataset.eventsView === 'calendar'; updateSelection(); }));
        year.addEventListener('change', () => {
            const firstCard = cards.find(card => !year.value || card.closest('.event-card-wrap').dataset.eventYears.split(' ').includes(year.value));
            month.value = firstCard && (!year.value || firstCard.dataset.eventStart.slice(0, 4) === year.value) ? firstCard.dataset.eventStart.slice(0, 7) : (year.value ? year.value + '-01' : currentMonth);
            updateSelection();
        });
        month.addEventListener('change', () => {
            // A month outside the selected year resets the year filter so results stay understandable.
            if (year.value && month.value.slice(0, 4) !== year.value) year.value = '';
            updateSelection();
        });
        function moveMonth(delta) {
            if (!/^\d{4}-\d{2}$/.test(month.value)) month.value = currentMonth;
            const parts = month.value.split('-').map(Number);
            const next = new Date(Date.UTC(parts[0], parts[1] - 1 + delta, 1));
            month.value = next.toISOString().slice(0, 7);
            if (year.value && month.value.slice(0, 4) !== year.value) year.value = '';
            updateSelection();
        }
        hub.querySelector('[data-calendar-previous]').addEventListener('click', () => moveMonth(-1));
        hub.querySelector('[data-calendar-next]').addEventListener('click', () => moveMonth(1));
        updateSelection();
    }

    document.querySelectorAll('[data-event-cta]').forEach(link => link.addEventListener('click', () => {
        // Respect the existing site's analytics/consent initialization; do not create a tracker.
        if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'event_cta_click', event_action: link.dataset.eventCta, event_title: document.querySelector('[data-event-page]')?.dataset.eventTitle || 'Events Hub' });
    }));
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseEvents);
else initialiseEvents();
